import { Character as SharedCharacter } from '../../components/atomic/character/character/Character';
import characterImg from './character.png';
import './Character.css';

/** From welcome_screen_1.svg → character (mask 269 1040 532×521). */
export function Character() {
  return (
    <SharedCharacter className="welcome-character" src={characterImg} />
  );
}
